module.exports = __webpack_public_path__ + "static/media/staff.650a9997.svg";